import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'
import qs from 'qs'

import compositeId from '../../compositeId'
import { USER } from '../users'
import { WORKFLOW } from '../workflows'

export const collection = 'results'

export const schema = new schemas.Entity(
  collection,
  {
    workflows: new schemas.Array(WORKFLOW.schema),
    users: new schemas.Array(USER.schema),
  },

  {
    idAttribute: compositeId('reportId', 'selectionId', 'pageNumber'),
  }
)

type QueryType = {
  reportId: string
  selectionId: string
}

type RequestParamsType = {
  pagesize: number
  offset: number
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  (
    { reportId, selectionId }: QueryType,
    _: unknown,
    { pagesize, offset }: RequestParamsType
  ) => {
    const requestParams = qs.stringify(
      { pagesize, offset },
      { addQueryPrefix: true }
    )

    return callApi(
      `${apiBase}/reports/${reportId}/results/${selectionId}${requestParams}`,
      schema
    )
  }
